import { FC } from 'react'
import { PropsWithChildren } from 'react'

import { useActiveClinic } from '@modules/active-clinic/core/ActiveClinicProvider'

const HasActiveClinic: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { activeClinic } = useActiveClinic()

  if (activeClinic) {
    return <>{children}</>
  }

  return null
}

export { HasActiveClinic }
